import sqftShapeManager from "../sqftShapeManager";
import workspace from "../../core/workspace";
import {WORKSPACE_RESOURCES} from "../../../../constants";
import {SQFTResourceController} from "./SQFTResourceController";
import ShapeHelper from "../../../../helpers/shapeHelper";
import workspaceControllers from "../workspaceControllers";
import store from "../../../../../../store";
import sqftShape from "../../core/shapes/sqftShape";
import MovableImage from "../../core/shapes/movableImage";
//import sqftShapeIntersectionsManager from "../sqftShapeIntersectionsManager";

export class SnappedShapeGroupsController extends SQFTResourceController {
  //snappedShapeGroups = [];

  constructor(props) {
    super(props);
    this.resourceName = WORKSPACE_RESOURCES.snappedShapeGroups;
  }

  addNewSnappedShapeGroupNumber = () => {
    const snappedShapeGroups = this.getResources();
    const newNumber = snappedShapeGroups.length > 0
      ? snappedShapeGroups[snappedShapeGroups.length - 1] + 1
      : 0;
    this.addResource(newNumber);

    return newNumber
  }

  setSameSnappedShapesGroup = (snappedShape, snappedWithShape) => {
    const snappedShapeGroup = snappedShape.shapeAbsolute.getSnappedShapeGroup();
    const snappedWithShapeGroup = snappedWithShape.shapeAbsolute.getSnappedShapeGroup();
    if (snappedWithShapeGroup !== null) {
      snappedShape.shapeAbsolute.setSnappedShapeGroup(snappedWithShapeGroup);
    } else if (snappedShapeGroup !== null) {
      snappedWithShape.shapeAbsolute.setSnappedShapeGroup(snappedShapeGroup);
    } else {
      const groupNumber = this.addNewSnappedShapeGroupNumber();
      snappedShape.shapeAbsolute.setSnappedShapeGroup(groupNumber);
      snappedWithShape.shapeAbsolute.setSnappedShapeGroup(groupNumber);
    }
  }

  // isShapeGroupConsistsOfOnlyCabinetShapes = (snappedShapeGroup) => {
  //   const shapes = this.getSnappedShapes(snappedShapeGroup);
  //   return !shapes.some(shape => shape.shapeCabinet === null);
  // }

  getMeasurementPoints = (snappedShapeGroup) => {
    const shapes = this.getSnappedShapes(snappedShapeGroup);
    if (shapes.length > 0) {
      let shapesPoints = [];
      shapes.forEach(shp => {
        shapesPoints.push(...shp.getPointsPointField());
      });
      let pointsMinMax = sqftShapeManager.getMinMaxPoints(shapesPoints, false);

      //console.log("shapesMinMax", pointsMinMax);

      return [
        {x: pointsMinMax.minX, y: pointsMinMax.minY},
        {x: pointsMinMax.maxX, y: pointsMinMax.minY},
        {x: pointsMinMax.maxX, y: pointsMinMax.maxY},
        {x: pointsMinMax.minX, y: pointsMinMax.maxY}
      ];
    }
    return []
  }

  getSnappedShapes = (snappedShapeGroup) => {
    const shapes = workspace.getShapes(true);
    return shapes.filter(shp => {
      return !!(shp.shapeAbsolute && (shp.shapeAbsolute.getSnappedShapeGroup() === snappedShapeGroup))
      || !!(shp.shapeSlab && shp.shapeSlab.shapeAbsolute && (shp.shapeSlab.shapeAbsolute.getSnappedShapeGroup() === snappedShapeGroup))
    })
  }

  // Updates the groups of snapped shapes in the workspace
  updateShapesSnappedGroups = (shouldUpdateAbsolutePos = false) => {
    // Sort shapes by their position
    const shapes = workspace.getShapes(true)
      .filter(shp => shp instanceof MovableImage || shp instanceof sqftShape)
      .sort((a, b) => {
      let aPos = a.getPosition();
      let bPos = b.getPosition();
      return aPos.x - bPos.x || aPos.y - bPos.y;
    });
    //const shapesPosition = shapes.map(shp => {return {id: shp.id, ...shp.getPosition()}});
    //sqftShapeIntersectionsManager.logSnappedShapeGroups();
    //console.log("shapesPosition", shapesPosition);
    const visitedShapes = new Set(); // To keep track of already processed shapes

    this.resetShapesSnappedGroups();

    for (const shape of shapes) {
      if ((shape instanceof sqftShape || shape instanceof MovableImage) && !visitedShapes.has(shape)) {
        this.updateGroupForShapeAndConnected(shape, visitedShapes, shouldUpdateAbsolutePos);
      }
    }

    //sqftShapeIntersectionsManager.logSnappedShapeGroups();
  }

  // Updates the groups of snapped shapes in the workspace
  resetShapesSnappedGroups = () => {
    const isShowSlabTool = store.getState().sqftSlabState.isShowSlabTool;
    const shapes = workspace.getShapes(true);

    for (const shape of shapes) {
      if (shape instanceof sqftShape) {
        const shapeAbsolute = isShowSlabTool ? shape.shapeSlab.shapeAbsolute : shape.shapeAbsolute;
        this.resetShapeSnappedGroup(shapeAbsolute);
      } else if (shape instanceof MovableImage) {
        this.resetShapeSnappedGroup(shape.shapeAbsolute);
      }
    }
  }

  // Updates the groups of snapped shapes in the workspace
  resetShapeSnappedGroup = (shapeAbsolute) => {
    shapeAbsolute.setSnappedWithShape(null);
    shapeAbsolute.setSnappedShapeGroup(null);
  }

  // Recursive function to update groups for a shape and all connected shapes
  updateGroupForShapeAndConnected = (shape, visitedShapes, shouldUpdateAbsolutePos) => {
    visitedShapes.add(shape);
    const connectedShapes = this.updateShapeSnappedGroup(shape, shouldUpdateAbsolutePos); // Update group for the current shape

    //console.log("shape id", shape.id);
    //console.log("shape shapeSlab.shapeAbsolute.getSnappedShapeGroup()", shape.shapeSlab.shapeAbsolute.getSnappedShapeGroup());
    // if (connectedShapes[0]) {
    //   console.log("connectedShapes 0 id", connectedShapes[0].id);
    //   console.log("shape shapeSlab.shapeAbsolute.getSnappedShapeGroup()", connectedShapes[0].shapeSlab.shapeAbsolute.getSnappedShapeGroup());
    // }
    // if (connectedShapes[1]) {
    //   console.log("connectedShapes 1 id", connectedShapes[1].id);
    //   console.log("shape shapeSlab.shapeAbsolute.getSnappedShapeGroup()", connectedShapes[1].shapeSlab.shapeAbsolute.getSnappedShapeGroup());
    // }
    //debugger // eslint-disable-line no-debugger

    // Retrieve connected shapes (this logic might vary based on your application)
    //const connectedShapes = ShapeHelper.getConnectedShapes(shape);

    for (const connectedShape of connectedShapes) {
      if (!visitedShapes.has(connectedShape)) {
        this.updateGroupForShapeAndConnected(connectedShape, visitedShapes);
      }
    }
  }

  /**
   * Update absolute shape position in regular or in slab mode. Also updates snapped shape group.
   * @param shape
   * @param shouldUpdateAbsolutePos
   * @return {*[]}
   */
  updateShapeSnappedGroup = (shape, shouldUpdateAbsolutePos) => {
    let isShowSlabTool = store.getState().sqftSlabState.isShowSlabTool;
    let snapPossibilitiesToShapes = [];
    let snapPossibilitiesToImages = [];
    let snapPossibilitiesToWalls = [];
    let shapeAbsolute;
    let pos;

    if (shape instanceof sqftShape) {
      shapeAbsolute = isShowSlabTool ? shape.shapeSlab.shapeAbsolute : shape.shapeAbsolute;
      pos = isShowSlabTool ? shape.slabPos : shape.pos;
    } else if (shape instanceof MovableImage) {
      shapeAbsolute = shape.shapeAbsolute;
      pos = shape.pos;
    }

    if (shouldUpdateAbsolutePos) {
      shapeAbsolute.setAbsolutePos(null); //reset minLength for correct calculations without stacking
    }
    // shapeAbsolute.setSnappedWithShape(null);
    // shapeAbsolute.setSnappedShapeGroup(null);

    let distancesToWalls = ShapeHelper.getDistancesToWalls(shape);
    let distancesToShapes = ShapeHelper.getDistancesToShapes(shape);
    let distancesToImages = ShapeHelper.getDistancesToImages(shape);
    //console.log("distancesToWalls", distancesToWalls);
    //console.log("distancesToShapes", distancesToShapes);
    //console.log("distancesToImages", distancesToImages);

    const itemBoundsWithSamePartId = ShapeHelper.getItemBoundsForTheSamePartIdIfExist(distancesToShapes, shape.partId);
    snapPossibilitiesToShapes = ShapeHelper.getSnappingPossibilities(itemBoundsWithSamePartId);
    if (snapPossibilitiesToShapes.length === 0) {
      snapPossibilitiesToShapes = ShapeHelper.getSnappingPossibilities(distancesToShapes);
    }
    //console.log("snapPossibilitiesToShapes", snapPossibilitiesToShapes);
    snapPossibilitiesToImages = ShapeHelper.getSnappingPossibilities(distancesToImages);
    snapPossibilitiesToWalls = ShapeHelper.getSnappingPossibilities(distancesToWalls);
    //console.log("snapPossibilitiesToShapes", snapPossibilitiesToShapes);

    //walls
    let [absolutePosToWalls, snappedWithWalls] = ShapeHelper.getAbsolutePosFromSnapPossibilities(snapPossibilitiesToWalls, pos);
    if (absolutePosToWalls) {
      if (shouldUpdateAbsolutePos) {
        shapeAbsolute.setAbsolutePos(absolutePosToWalls);
      }
      void snappedWithWalls;
      //snappedWithImage.shapeAbsolute.setSnappedWithImage(this);
    }

    //shapes
    let [absolutePosToShapes, snappedWithShape] = ShapeHelper.getAbsolutePosFromSnapPossibilities(snapPossibilitiesToShapes, pos);
    if (absolutePosToShapes) {
      if (shouldUpdateAbsolutePos) {
        shapeAbsolute.setAbsolutePos(absolutePosToShapes);
      }
      if (isShowSlabTool) {
        if (snappedWithShape.shapeSlab && snappedWithShape.shapeSlab.shapeAbsolute) {
          snappedWithShape.shapeSlab.shapeAbsolute.setSnappedWithShape(shape.shapeSlab);
        }
        if (shape.shapeSlab && shape.shapeSlab.shapeAbsolute) {
          shape.shapeSlab.shapeAbsolute.setSnappedWithShape(snappedWithShape);
        }
      } else {
        snappedWithShape.shapeAbsolute.setSnappedWithShape(shape);
        shape.shapeAbsolute.setSnappedWithShape(snappedWithShape);
      }

      // set same snapped shape group for all shapes
      const snappedShape = isShowSlabTool && shape.shapeSlab ? shape.shapeSlab : shape;
      const snappedShapeIds = Object.keys(distancesToShapes);
      for (const shapeId of snappedShapeIds) {
        const snappedShapeFromAllPossibilities = workspace.getShapeById(parseInt(shapeId));
        const shapeSlab = snappedShapeFromAllPossibilities.shapeSlab
        snappedWithShape = isShowSlabTool && shapeSlab ? shapeSlab : snappedShapeFromAllPossibilities;
        workspaceControllers.snappedShapeGroups.setSameSnappedShapesGroup(snappedShape, snappedWithShape);
      }
    }

    //images
    let [absolutePosToImages, snappedWithImage] = ShapeHelper.getAbsolutePosFromSnapPossibilities(snapPossibilitiesToImages, pos);
    if (absolutePosToImages) {
      if (shouldUpdateAbsolutePos) {
        shapeAbsolute.setAbsolutePos(absolutePosToImages);
      }
      void snappedWithImage;
      //snappedWithImage.shapeAbsolute.setSnappedWithImage(this);
    }

    //allSnappedPossibilities
    return [
      ...snapPossibilitiesToShapes.map(snapPossibility => snapPossibility.shape),
      ...snapPossibilitiesToImages.map(snapPossibility => snapPossibility.shape)
    ];
  }
}
